
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/download/lean",
      function () {
        return require("private-next-pages/download/lean/index.tsx");
      }
    ]);
  